import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyFlatCreateRequestDTO,
	postPropertyFlatV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePostPropertyFlatMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(requestContract: ClientPropertyFlatCreateRequestDTO) =>
				postPropertyFlatV2(requestContract),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.propertyList() });
		},
	});
};
